<template>
    <div v-if="chat" class="friend-memo" @click.stop>
        <i
            @click="onClickMemo"
            @mouseover="showSbMemo = true"
            @mouseleave="showSbMemo = false"
            class="zmdi zmdi-edit"
            :class="{ active: friendMemoOpened }"
        />
        <Snackbar :bind="showSbMemo" :text="'MEMO'" />
        <transition name="fade">
            <div v-show="friendMemoOpened" class="memo">
                <textarea
                    v-model="chat.memo"
                    @keydown="onKeydown"
                    :placeholder="$translate('PLACEHOLDER_FRIEND_MEMO')"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import chatService from '@/services/chat'
import debounce from '@/modules/debounce'

export default {
    name: 'FriendMemo',
    props: ['chat'],
    data: () => ({
        friendMemoOpened: false,
        showSbMemo: false,
    }),
    watch: {
        chat() {
            this.friendMemoOpened = false
        },
    },
    methods: {
        onKeydown: debounce(async function (event) {
            const memo = event.target.value || ''
            try {
                await chatService.update(this.chat.id, { memo })
            } catch (e) {}
        }, 200),
        onClickMemo() {
            if (!this.chat) {
                this.$toast.error('ERROR_MEMO_NOT_FRIEND')
                return
            }

            this.friendMemoOpened = !this.friendMemoOpened
        },
    },
}
</script>

<style lang="scss" scoped>
.friend-memo {
    position: relative;

    textarea {
        font-size: 12px;
        border: none;
        width: 100%;
        height: 100%;

        &:active,
        &:focus {
            border: none;
            box-shadow: none;
        }
    }

    .memo {
        border: 1px solid $grey-04;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
        border-radius: 12px;
        background: $white;
        position: absolute;
        z-index: 2;
        padding: 16px;
        width: 400px;
        height: 600px;
        top: 161px;
        left: -180px;
        cursor: initial;
    }
}
</style>
